import { useCallback, useEffect, useState, Fragment } from 'react'
import { Button, Dialog, DialogContent, Grid, Typography } from '@material-ui/core'
import ShortcutButtons from '../components/Dashboard/ShorcutButtons'
import ContactIcon from '@material-ui/icons/MailOutline'
import WarningForm from './General/WarningForm'
import Incidences from './General/Incidences'
import AlertIcon from '@material-ui/icons/NotificationsActiveOutlined'
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModalFullscreen } from '../redux/features/modalSlice'

export default function HomeView() {
  const [isModalContactOpen, setIsModalContactOpen] = useState(false)
  const [isModalIncidencesOpen, setIsModalIncidencesOpen] = useState(false)

  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  const handleCloseModalContact = () => {
    setIsModalContactOpen(false)
  }

  const exitFullscreenModalContact = useCallback(() => {
    if (!isModalContactOpen && modal.showFullscreenOption) {
      dispatch(toggleModalFullscreen(false))
    }
  }, [isModalContactOpen, modal.showFullscreenOption, dispatch])

  useEffect(() => {
    let timeout = setTimeout(exitFullscreenModalContact, 500)
    return () => clearTimeout(timeout)
  }, [isModalContactOpen, exitFullscreenModalContact])

  const handleCloseModalIncidences = () => {
    setIsModalIncidencesOpen(false)
  }

  let extraShortcuts = [
    {
      action: () => setIsModalIncidencesOpen(true),
      shortcutTitle: 'Contestar mis incidencias',
      icon: <AssignmentLateOutlinedIcon color="secondary" />
    },
    {
      action: () => document.getElementById('notificationButton').click(),
      shortcutTitle: 'Revisar mis notificaciones',
      icon: <AlertIcon color="secondary" />
    }
  ]

  return (
    <Fragment>
      <Grid container spacing={3} className="justify-content-center text-center">
        <Grid item xs={12} md={12} lg={10}>
          <ShortcutButtons extraShortcuts={extraShortcuts} />
        </Grid>
        <Grid item xs={12} lg={7}>
          <Typography color="secondary" variant="h5">
            Bienvenido al portal del Proveedor de Conway
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color="primary">
            El nuevo espacio digital de comunicación con nuestros colaboradores. Desde aquí podrás
            acceder a múltiples funcionalidades.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<ContactIcon fontSize={'small'} />}
            onClick={() => setIsModalContactOpen(true)}
          >
            Contactar con Conway
          </Button>
        </Grid>
      </Grid>
      <Dialog
        open={isModalContactOpen}
        onClose={handleCloseModalContact}
        maxWidth={'sm'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <WarningForm onClose={handleCloseModalContact} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalIncidencesOpen}
        onClose={handleCloseModalIncidences}
        maxWidth={'sm'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <Incidences onClose={handleCloseModalIncidences} />
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}
